import React from 'react'
import { makeStyles } from '@mui/styles'
import { create } from 'react-modal-promise'

import IconCheck from '@assets/images/icons/check.svg'
import IconTrashcan from '@assets/images/icons/trashcan.svg'
import { ButtonIconSquare, CancelButton } from '@/modules/base/components/buttons'
import { ModalBig } from '@/modules/base/components/modal'
import lang from '@/lang'

export const AwaitableConfirmationModalIcons = {
  checkIcon: IconCheck,
  trashcanIcon: IconTrashcan,
}

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    margin: '0 auto',
  },
  buttonRow: {
    margin: theme.spacing(1),
  },
}))

export const AwaitableConfirmationModal = (props) => {
  const {
    isOpen,
    title,
    description,
    onResolve,
    onReject,
    cancelLabel = lang.generics.no,
    confirmLabel = lang.generics.yes,
    cancelReject = false,
    confirmIcon = AwaitableConfirmationModalIcons.checkIcon,
    // Callers that must force an explicit button choice pass these through to ModalBig
    // (default undefined ⇒ existing callers keep the dismissible behaviour).
    disableEscapeKeyDown,
    disableBackdropClick,
    // ModalBig's close icon calls onClose directly, bypassing both disable* gates — a
    // caller forcing an explicit decision must therefore lose the X by default too.
    // (Destructured AFTER the disable* props: an earlier default may not reference later
    // bindings.) Explicit showCloseIcon still wins.
    showCloseIcon = !(disableEscapeKeyDown || disableBackdropClick),
  } = props
  const classes = useStyles()

  return (
    <ModalBig
      title={title}
      open={isOpen}
      onClose={() => cancelReject ? onReject() : onResolve(false) }
      showCloseIcon={showCloseIcon}
      disableEscapeKeyDown={disableEscapeKeyDown}
      disableBackdropClick={disableBackdropClick}
    >
      <div>
        <p dangerouslySetInnerHTML={{ __html: description }} />
        <div className={classes.button} key="modal-buttons">
          <CancelButton
            key="cancel-button"
            customClass={classes.buttonRow}
            label={cancelLabel}
            onClick={() => cancelReject ? onReject() : onResolve(false) }
          />
          <ButtonIconSquare
            key="submit-button"
            customClass={classes.buttonRow}
            label={confirmLabel}
            icon={confirmIcon}
            onClick={() => onResolve(true)}
          />
        </div>
      </div>
    </ModalBig>

  )
}

export const awaitableConfirmationModal = create(AwaitableConfirmationModal)
